<template>
  <div class="pharmacyrecord">
    <el-row>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
        <kt-button label="上一天" type="primary" @click="handlePrevDay" />
        <el-date-picker
          :editable="false"
          :clearable="false"
          v-model="dateValue"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          @change="filterTable"
        ></el-date-picker>
        <kt-button label="下一天" type="primary" @click="handleNextDay" />
        <el-form-item label="老人姓名" style="margin-left: 30px">
          <el-input
            v-model.trim="filters.oldmanName"
            placeholder="请输入姓名"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage"
          />
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="oldmanName"
          label="姓名"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="drug"
          label="药品"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="standard"
          label="规格"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="number"
          label="数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="usages"
          label="用法"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="recordTime"
          label="喂药时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="state"
          label="完成状态"
          align="center"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="changepage"
      align="center"
    ></el-pagination>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "PharmacyRecord",
  components: { KtTable, KtButton },
  data() {
    return {
      loading: true,
      size: "medium", //按钮的尺寸
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      tableData: [], //表格数据
      filters: {
        oldmanName: "",
      },
      total: 0, //分页总数
      pageNum: 1,
      pageSize: 10,
    };
  },
  methods: {
    //翻页
    changepage(val) {
      this.pageNum = val;
      this.findPage();
    },
    //enter键查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    //上一天
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      doday = Date.parse(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dateValue = nowDate;
      this.findPage();
    },
    //下一天
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dateValue = nowDate;
      this.findPage();
    },

    //时间筛选条件
    filterTable(val) {
      this.dateValue = val;
      this.findPage();
    },

    //查询列表
    findPage(data) {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName: this.filters.oldmanName,
        date: this.dateValue,
        nursingGroupId: sessionStorage.getItem("nursingGroupId"),
      };
      this.$postJson("omc/medicRecord/queryListWithPage", param).then((res) => {
        this.tableData = res.result.list;
        this.total = Number(res.result.total);
        let usagesMap = new Map([
          [1, "一天一次"],
          [2, "一天二次"],
          [3, "一天三次"],
          [4, "一天四次"],
        ]);
        let stateMap = new Map([
          [1, "提交申请"],
          [2, "发布计划"],
          [3, "护工领任务"],
          [4, "护工确认"],
          [5, "班长确认"],
          [6, "领取任务超时"],
          [7, "护工确认超时"],
          [8, "班长确认超时"],
          [9, "班长补签"],
        ]);
        this.tableData = this.tableData.map((element) => {
          element.state = stateMap.get(element.state);
          element.usages = usagesMap.get(element.usages);
          return element;
        });
      });
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  created() {},
  mounted() {
    this.findPage();
  },
};
</script>
<style lang="scss" scoped>
.pharmacyrecord {
  width: 100%;
  min-height: 500px;
  background: #fefefe;
}
</style>
